








































import Vue from "vue"
import HorizontalCardListItem from "~/components/guideline/horizontalCardList/HorizontalCardListItem.vue"

export default Vue.extend({
  components: {
    HorizontalCardListItem,
  },
  props: {
    linkPath: {
      type: String,
      required: true,
    },
    fullName: {
      type: String,
      required: true,
    },
    profileImageUrl: {
      type: String,
      required: true,
    },
    corporationLogoImageUrl: {
      type: String,
      default: null,
    },
    corporationName: {
      type: String,
      default: null,
    },
    // 企業が在籍中の企業かどうかを示すフラグ
    isCurrentCorporation: {
      type: Boolean,
      default: null,
    },
  },
  computed: {
    truncatedCorporationName(): string | null {
      if (!this.corporationName) return null

      const maxLength = this.corporationLogoImageUrl ? 30 : 35
      return this.corporationName.length <= maxLength
        ? this.corporationName
        : this.corporationName.substr(0, maxLength) + "..."
    },
  },
})
